import React, { useState, useEffect, useMemo } from 'react';
import Translations from '../../services/translation.service';
import Call from "../../assets/img/stm-call.svg";
import Account from "../../assets/img/stm-account.svg";
import Data from "../../assets/img/stm-data.svg";
import CheckIcon from "../../assets/img/TickCheckIcon.svg";
import CloseIcon from "../../assets/img/CloseIconAct.svg";
import Summaries from '../../services/summaries.service';
import Helpers from "../../helpers/shared.helper";
import Plans from '../../services/plans.service';
import * as variables from '../../variables';
import storefront from '../../services/storefront.service';
import StmSummarySkeleton from '../skeleton/storefront-summary';
import Storage from '../../services/storage.service';
import CONSTANTS from '../../services/constants.service';
import StmSummaryAmanFeatureRows from './stm-summary-aman-feature-rows.component';
import {
    resolveAmanFeatureAttributes,
    hasAmanFeatureSummaryAttributeData,
} from '../../helpers/aman-feature.helper';

const subscriptions = [];
let prefix = "stm_sum_";
let prefix_general = "stm_general_";
const ActivationSummary = ({ showUserAccount = false }) => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [loader, setLoader] = useState(false);
    const [numberData, setNumberData] = useState(null);
    const [savedPlans, setSavedPlans] = useState([]);
    const [planPromotions, setPlanPromotions] = useState([]);
    const [finalAmount, setFinalAmount] = useState("");
    const [paymentStatus, setPaymentStatus] = useState(false);
    const [showPaymentStatus, setShowPaymentStatus] = useState(false);
    const [planCode, setPlanCode] = useState("");
    const [planId, setPlanId] = useState(null);
    const [featureAttributes, setFeatureAttributes] = useState([]);

    const numberType = useMemo(() => {
        return translationKeys[`general_vanity_name_${numberData?.VanityLevelID || 0}number`]
    }, [numberData, translationKeys])

    const {addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues} = useMemo(()=>{
        const freeAddons = []
        const dataBonus = []
        const minutesBonus = []
        const smsBonus = []
        const freePlanPromotions = planPromotions?.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
        for (let promotion of freePlanPromotions) {
          const parsed = JSON.parse(promotion["Value"]);
          switch (parsed.Type) {
            case variables.PROMOTION_TYPE_VOICE_ON_NET:
            case variables.PROMOTION_TYPE_DATA_SOCIAL:
              freeAddons.push(parsed);
              break;
            case variables.PROMOTION_TYPE_DATA:
              dataBonus.push(parsed);
              break;
            case variables.PROMOTION_TYPE_VOICE_LCL:
              minutesBonus.push(parsed);
              break;
            case variables.PROMOTION_TYPE_SMS:
              smsBonus.push(parsed);
              break;
            default:
          }
        }
    
        for (let plans of savedPlans) {
          if(plans.Type === variables.PROMOTION_TYPE_DATA_SOCIAL) {
            freeAddons.push({Type: plans.Type, Value: plans.Value});
          }
        }
        
        let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
        let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
        let smsBonusValues = Plans.getSumData(smsBonus, variables.PROMOTION_TYPE_SMS, "sms");
        let addonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb")
    
        return {addonsValues, dataBonusValues, minutesBonusValues, smsBonusValues}
    },[planPromotions, savedPlans])

    const showAmanSummaryFeatureRows = useMemo(() => {
        const attrs = resolveAmanFeatureAttributes({ planCode, planId, selectedCard: null });
        return hasAmanFeatureSummaryAttributeData(attrs);
    }, [planCode, planId]);

    const amanPlanHeaderTitle = useMemo(() => {
        if (!showAmanSummaryFeatureRows || !planCode) {
            return "";
        }
        const planCodeNorm = planCode
            .replaceAll("-", "_")
            .replaceAll(" ", "")
            .replaceAll(",", "")
            .toLowerCase();
        const nameKey = `general_plan_name_${planCodeNorm}`;
        return (
            translationKeys[nameKey] ||
            planCode ||
            translationKeys["general_plan_custom"] ||
            ""
        );
    }, [showAmanSummaryFeatureRows, planCode, translationKeys]);

  const renderPlanDetailsAll = (plan) => {
    let content = null;
    let flagZero = 0;
    if (plan?.Unit === "sms") {
      // FOR "SMS-LCL"
      if (plan?.Value === -1 || smsBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
        </>;
      } else {
        if (smsBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${smsBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + smsBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "sms_unit"]}</span>
          </>;
        }
      }
    }

    if (plan?.Unit === "bytes") {
      // FOR "DATA" & "DATA-SOCIAL"
      if (plan?.Value === -1 || dataBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
        </>;
      } else {
        if (dataBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${dataBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + dataBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
          </>;
        }
      }
    }

    if (plan?.Unit === "milliseconds") {
      // For "VOICE-LCL"
      if (plan?.Value === -1 || minutesBonusValues < 0) {
        flagZero = 1;
        content = <>
          {translationKeys["free_addons_unlimited"]}{" "}
          <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
        </>;
      } else {
        if (minutesBonusValues > 0) {
          flagZero = 1;
          content = <>
            <span>{`(${storefront.getPlanDataMinValue(plan?.Value, plan?.Type)} + ${minutesBonusValues}) = ${storefront.getPlanDataMinValue(plan?.Value, plan?.Type) + minutesBonusValues}`}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        } else {
          flagZero = storefront.getPlanDataMinValue(plan?.Value, plan?.Type);
          content = <>
            <span>{storefront.getPlanDataMinValue(plan?.Value, plan?.Type)}{" "}</span>
            <span className="unit">{translationKeys[prefix_general + "minute_unit"]}</span>
          </>;
        }
      }
    }
    const planValueObj = {
      content: content,
      flagZero: flagZero
    } 
    return planValueObj;
  }

    useEffect(() => {
        setLoader(true);
        Summaries.getSummary()
            .then((res) => {
                if (res?.data) {
                    const firstSaved = res?.data?.saved_plans?.[0];
                    if (firstSaved?.Plans?.length) {
                        setFinalAmount(res?.data?.total_amount_vat_included);
                        setSavedPlans(firstSaved.Plans);
                        setPlanPromotions(firstSaved.PlanPromotions || []);
                        setPlanCode(firstSaved?.PlanCode || "");
                        setPlanId(firstSaved?.ID != null ? firstSaved.ID : null);
                        setFeatureAttributes(firstSaved?.FeatureAttributes || []);
                        const flags = Storage.get("flags");
                        if(flags?.onboardingChargeCaptured) {
                          setPaymentStatus(flags.onboardingChargeCaptured)
                        }
                        if(flags?.SIMActivated) {
                          setShowPaymentStatus(flags?.SIMActivated);
                        }
                    }
                    if (res?.data?.number_details) {
                        setNumberData(res?.data?.number_details);
                    }
                }
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    }, []);
    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);
    return (
        <>
            {
                loader ? <StmSummarySkeleton /> : <div className='stm-sum-wrapper'>

                   {Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE) && showPaymentStatus && 
                      <>
                        {paymentStatus ? 
                        <div className='stm-act-card'>
                          <div className='act-payment-success'>
                            <img src={CheckIcon} alt='' />
                            <span>{translationKeys["stf_act_payment_cap_success_line_1"] || "Your payment of"}{" "}{`${finalAmount} ${translationKeys["stm_general_currency"]}`}{" "}{translationKeys["stf_act_payment_cap_success_line_2"] || "has been successfully processed"}</span>
                          </div>
                        </div>
                        :
                        <div className='stm-act-card'>
                          <div className='act-payment-failed'>
                            <img src={CloseIcon} alt='' />
                            <div>
                              <span>{translationKeys["stf_act_payment_cap_failed"] || "Payment Failed"}</span>
                              <p>{translationKeys["stf_act_payment_cap_failed_desc"] || "The card issuer has declined the payment, Please contact your bank or use a different card."}</p>
                            </div>
                          </div>
                        </div>
                        }
                      </>
                    }

                    <div className='stm-act-card'>
                        <div className="stm-act-logo">
                            <img src={Call} alt="call" />
                            <span>
                                {translationKeys[prefix + "your_number"]}</span>
                        </div>

                        <div className='stm-act-grid'>
                            <div className="stm-act-block-left">{numberType}</div>
                            <div className="stm-act-block-right">{numberData?.MSISDN}</div>
                        </div>

                    </div>
                    {showUserAccount && Storage.get("user-email", true) &&
                      <div className='stm-act-card'>
                          <div className="stm-act-logo">
                            <img src={Account} alt="call" />
                            <span>{translationKeys[prefix + "account_info"] || "Account info"}</span>
                          </div>
                          <div className='stm-act-grid'>
                            <div className="stm-act-block-left">{translationKeys[prefix + "email"] || "Email"}</div>
                            <div className="stm-act-block-right">{Storage.get("user-email", true)}</div>
                          </div>
                      </div>}
                    {!showUserAccount &&
                      <div className='stm-act-card'>
                          <div
                              className={
                                  "stm-act-logo" +
                                  (finalAmount ? " stm-act-logo--plan-with-price" : "")
                              }
                          >
                              <div className="stm-act-logo__main">
                                  <img src={Data} alt="" />
                                  <span>
                                      {showAmanSummaryFeatureRows && amanPlanHeaderTitle
                                          ? Helpers.nextLineText(amanPlanHeaderTitle, "span")
                                          : translationKeys["scr_3.10_A_signup_step_plan_name"]}
                                  </span>
                              </div>
                              {finalAmount ? (
                                  <span className="stm-act-logo__price">
                                      {finalAmount}{" "}
                                      {translationKeys[prefix_general + "currency"]}
                                  </span>
                              ) : null}
                          </div>
                          {!!savedPlans.length && (
                          <>
                              <div className='stm-act-grid'>
                              {savedPlans.map((plan) => {
                                  const contentService = Helpers.getStreaminService();
                                  if(plan?.Type !== variables.PROMOTION_TYPE_DATA_SOCIAL && 
                                  !contentService?.includes(plan?.Type?.toLowerCase())
                                  ) {
                                  return(
                                    renderPlanDetailsAll(plan)?.flagZero > 0 ?
                                    <React.Fragment key={plan.ID}>
                                        <div className="stm-act-block-left">
                                        {translationKeys[prefix_general + plan?.Type.replaceAll("-", "_").replaceAll(" ", "").toLowerCase()] ? translationKeys[prefix_general + plan?.Type.replaceAll("-", "_").replaceAll(" ", "").toLowerCase()] : plan?.Type}
                                        </div>
                                        <div className="stm-act-block-right">
                                        {renderPlanDetailsAll(plan)?.content}
                                        </div>
                                    </React.Fragment> : ""
                                    )
                                  } else {
                                  return ""
                                  }
                              })}

                              {addonsValues !== 0 &&
                              <>
                                  <div className="stm-act-block-left">
                                  {Translations.keys['stm_general_data_social']}
                                  </div>
                                  <div className="stm-act-block-right">
                                  {addonsValues === -1 ? translationKeys["free_addons_unlimited"] : addonsValues}{" "}<span className="unit">{translationKeys[prefix_general + "data_unit"]}</span>
                                  </div>
                              </>}
                              {showAmanSummaryFeatureRows ? (
                                  <StmSummaryAmanFeatureRows
                                      planCode={planCode}
                                      planId={planId}
                                      featureAttributes={featureAttributes}
                                  />
                              ) : null}
                              </div>
                          </>
                          )}
                      </div>
                    }
                </div>
            }

        </>
    )
}


export default ActivationSummary
